import styled from 'styled-components';

export const Container = styled.footer`
    border-top: 1px solid #e8e8e8;
    z-index: 12;
    position: sticky;
    bottom: 0;
    display: flex;
    padding: 16px;
    align-items: center;
    width: 100%;
    background: #fff;
`;

export const LeftElement = styled.div`
  margin-right: auto;
`;

export const RightElement = styled.div`
  margin-left: auto;
`;
